import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '@sharedModule/directives/control-value-accessor.directive';
import { InputData } from '@sharedModule/models/input-data.model';

@Component({
  selector: 'app-auth-input',
  templateUrl: './auth-input.component.html',
  styleUrl: './auth-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuthInputComponent),
      multi: true,
    },
  ],
})
export class AuthInputComponent<T> extends ControlValueAccessorDirective<T> {
  @Input() inputData!: InputData;
  hide = true;
}
